import { OrderBookingMode } from '@vista-digital/ocapi-types/v1';
import { hasShowtimeFilmEnded, isShowtimeAdmitting, isShowtimePlaying } from '../../browsing/utils/showtimes/showtime-utils';
import { getOrderRelatedFilmById } from '../../order/selectors/films/get-order-related-film-by-id';
import { getOrderRelatedShowtimeById } from '../../order/selectors/showtimes/get-order-related-showtime-by-id';
import { hasOrderShowtimeBeenFullyAdmitted, hasOrderShowtimeBeenFullyRefunded } from '../../order/utils/order-showtime-utils';
export var JourneyOrderShowtimeStatus;
(function (JourneyOrderShowtimeStatus) {
    JourneyOrderShowtimeStatus["Refunded"] = "Refunded";
    JourneyOrderShowtimeStatus["Pending"] = "Pending";
    JourneyOrderShowtimeStatus["Admitting"] = "Admitting";
    JourneyOrderShowtimeStatus["Admitted"] = "Admitted";
    JourneyOrderShowtimeStatus["NowPlaying"] = "NowPlaying";
    JourneyOrderShowtimeStatus["Expired"] = "Expired";
    JourneyOrderShowtimeStatus["Unpaid"] = "Unpaid";
})(JourneyOrderShowtimeStatus || (JourneyOrderShowtimeStatus = {}));
/**
 * Returns the current status of a journey order showtime
 */
export function getJourneyOrderShowtimeStatus(journey, orderShowtime) {
    const showtime = getOrderRelatedShowtimeById(orderShowtime.showtimeId);
    if (!showtime) {
        throw new Error(`Showtime ${orderShowtime.showtimeId} not found. Cannot get status of journey order showtime`);
    }
    const film = getOrderRelatedFilmById(showtime.filmId);
    if (!film) {
        throw new Error(`Showtime film ${showtime.filmId} not found. Cannot get status of journey order showtime`);
    }
    // Order is unpaid
    if (isUnpaidBookingOrder(journey, showtime.id))
        return JourneyOrderShowtimeStatus.Unpaid;
    // Showtime has been refunded
    if (hasOrderShowtimeBeenFullyRefunded(orderShowtime))
        return JourneyOrderShowtimeStatus.Refunded;
    // Showtime has expired
    if (hasShowtimeFilmEnded(showtime))
        return JourneyOrderShowtimeStatus.Expired;
    // Showtime has been collected
    if (hasOrderShowtimeBeenFullyAdmitted(orderShowtime))
        return JourneyOrderShowtimeStatus.Admitted;
    // Film has started playing
    if (isShowtimePlaying(showtime))
        return JourneyOrderShowtimeStatus.NowPlaying;
    // Film has not started playing
    if (isShowtimeAdmitting(showtime))
        return JourneyOrderShowtimeStatus.Admitting;
    // Showtime is pending
    return JourneyOrderShowtimeStatus.Pending;
}
/**
 * Returns true if a given showtime status is an active status
 */
export const isActiveJourneyOrderShowtimeStatus = (status) => status === JourneyOrderShowtimeStatus.Pending ||
    status === JourneyOrderShowtimeStatus.Admitting ||
    status === JourneyOrderShowtimeStatus.Admitted ||
    status === JourneyOrderShowtimeStatus.NowPlaying ||
    status === JourneyOrderShowtimeStatus.Unpaid;
/**
 * Returns true if a given showtime status is an inactive status
 */
export const isInactiveJourneyOrderShowtimeStatus = (status) => status === JourneyOrderShowtimeStatus.Refunded || status === JourneyOrderShowtimeStatus.Expired;
const isUnpaidBookingOrder = (journey, showtimeId) => {
    var _a;
    const orderForShowtime = journey.orders.find(order => order.showtimes.find(s => s.showtimeId === showtimeId));
    return ((_a = orderForShowtime === null || orderForShowtime === void 0 ? void 0 : orderForShowtime.booking) === null || _a === void 0 ? void 0 : _a.mode) === OrderBookingMode.Unpaid;
};
